import React, { useCallback } from 'react';
import styled from 'styled-components';
import Header from 'shared/components/WelcomeBack/Header';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { Answer } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import { Report } from 'shared/components/WelcomeBack/utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface ReportFinalizeProps {
  report: Report;
  answers: Answer[];
  isLoading: boolean;
  isThirdParty: boolean;
  isInterim?: boolean;
  handlePressSection: (sectionId: number) => unknown;
  setIsReportInprogress: (show: boolean) => unknown;
  handlePressOption: (secId: number, optId: number) => unknown;
}

const FINAL_SUBHEADING =
  'Typically, you only need to update your final results and budget numbers now. But if there are any other changes you need to ' +
    'make, you can do so now.';

const INTERIM_SUBHEADING =
  'Usually you’ll just need to update your interim forecasts and budget figures. But if anything else needs changing, you can edit ' +
    'it here too.';

const StyledDiv = styled.div`
  .program-name {
    text-align: center;
    margin-bottom: 0;
    padding: ${SPACERS.medium};
    background-color: ${COLORS.grayLight};
  }
  .finalize-page-content {
    max-width: 504px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    .heading {
      margin-top: ${SPACERS.extraLarge};
      margin-bottom: ${SPACERS.extraLarge};
    }
    .subheading {
      margin-bottom: ${SPACERS.extraLarge};
    }
    .go-button {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const ReportFinalize: React.FC<ReportFinalizeProps> = ({
  report,
  isLoading,
  isThirdParty,
  isInterim = false,
  answers,
  handlePressOption,
  setIsReportInprogress,
  handlePressSection,
}) => {
  const reportTypeLabel = isInterim ? 'interim' : 'final';
  const handleClick = useCallback(() => {
    setIsReportInprogress(true);
    handlePressSection(isInterim ? 2 : 3);
  }, [setIsReportInprogress, handlePressSection]);

  return (
    <StyledDiv>
      {report.programName && (
        <TrueImpactText variant="heading" className="program-name">
          {report.programName}
        </TrueImpactText>
      )}
      <Header report={report} isThirdParty={isThirdParty} />
      <div className="finalize-page-content">
        <TrueImpactText className="heading" variant="heading-page">
          {`It’s time to make ${reportTypeLabel} updates for your report.`}
        </TrueImpactText>
        <TrueImpactText className="subheading">
          {isInterim ? INTERIM_SUBHEADING : FINAL_SUBHEADING}
        </TrueImpactText>
        <TrueImpactButton
          className="go-button"
          isLoading={isLoading}
          onClick={handleClick}
        >
          {isInterim ? 'Update Interim Report' : 'Let’s go!'}
        </TrueImpactButton>
      </div>
    </StyledDiv>
  );
};

export default ReportFinalize;
